import React, { useState } from 'react';
import { Page, Pane, PaneBody, PaneHeader } from '../../components/atoms/applications/page';
import './withdrawalApplyPage.module.scss';
import moment from 'moment-timezone';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { LabelPrimary } from '../../components/atoms/labels/LabelPrimary';
import DesktopWithdrawalPeriodImage1 from './images/period1.png';
import DesktopWithdrawalPeriodImage2 from './images/period2.png';
import { CheckBox } from '@sheinc/design-system';
import { V3Routes } from '../../routes';
import { ISODate } from '../../../commonv3/types/dates';
import { authenticated } from '../../../mainv2/components/auth/authenticated';
import { observer } from 'mobx-react';
import { WithdrawalDateTimeWithDow } from '../../components/atoms/withdrawals/WithdrawalDateTime';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import { Button } from '@sheinc/shelikes-design-system';

function paymentEveryMonth(withdrawalApplicableDates: ISODate[]) {
  if (
    withdrawalApplicableDates.length > 1 &&
    moment(withdrawalApplicableDates[1]).diff(withdrawalApplicableDates[0], 'month') === 1
  ) {
    return true;
  } else {
    return false;
  }
}

export const WithdrawalApplyPage = withNavigation(
  NavigationSpecs.side(),
  NavigationSpecs.none()
)(
  authenticated(
    observer(() => {
      const [checked, setChecked] = useState(false);
      const currentUser = GlobalStatesV3.currentUser;
      if (!currentUser.isSignedIn()) {
        return;
      }
      const withdrawalApplicableDates = currentUser.currentUser.withdrawal_applicable_dates;
      if (!withdrawalApplicableDates || withdrawalApplicableDates.length === 0) {
        GlobalStatesV3.routing.push(V3Routes.home());
        return null;
      }
      moment.locale('ja');
      const ScheduleDate = () => {
        if (paymentEveryMonth(withdrawalApplicableDates)) {
          return (
            <div styleName="schedule_date">
              毎月<span styleName="date">{moment(withdrawalApplicableDates[0]).format('DD')}</span>日
            </div>
          );
        } else {
          return (
            <div styleName="schedule_date">
              <span styleName="date">{moment(withdrawalApplicableDates[0]).format('YYYY/MM/DD')}</span>
            </div>
          );
        }
      };
      const earliestApplicableDate = withdrawalApplicableDates[0];
      const breadCrumbItems = [{ text: '退会について' }];
      return (
        <Page id="withdrawal-apply-page">
          <Pane styleName="pane">
            <PaneHeader title="退会について">
              <BreadCrumb items={breadCrumbItems} hasHome />
            </PaneHeader>
            <PaneBody>
              <div styleName="schedule_box">
                <div styleName="schedule_box_left">
                  <div styleName="schedule_text">{currentUser.currentUser.name}さんの課金更新日</div>
                  <ScheduleDate />
                </div>
                <div styleName="schedule_box_right">
                  <div styleName="schedule_text">
                    <WithdrawalDateTimeWithDow
                      dateTime={moment(earliestApplicableDate).add(-9, 'days').add(-1, 'second')}
                    />
                    <span styleName="schedule_text_light">までの申請で最短</span>
                    <br />
                    <WithdrawalDateTimeWithDow dateTime={moment(earliestApplicableDate)} />
                    <span styleName="schedule_text_light">での退会が可能です</span>
                  </div>
                  <div styleName="schedule_note">
                    ※退会日前日の23:59までサービスをご利用いただけます
                    <br />
                    ※slackの退会処理には数日かかる場合がございます
                  </div>
                </div>
              </div>
              <div styleName="attention">
                <div styleName="process">
                  <LabelPrimary label="退会の手順について" />
                  <div styleName="text">
                    ・次ページの退会申請フォームへ必要事項を入力し、申請をお願いいたします。
                    <br />
                    ・申請いただいた退会希望日を迎えたタイミングで正式に退会となります。
                    <br />
                    ※プラン変更／休会申請中の退会をご希望の場合には、
                    <a target="_blank" href={V3Routes.plan().pathname}>
                      【プランの確認 ／ 変更】
                    </a>
                    より申請を取り消していただき、退会のお手続きをお願いいたします。
                  </div>
                </div>
                <div>
                  <LabelPrimary label="注意事項" />

                  <div styleName="attention_text">
                    ・最短での退会をご希望の場合は、課金更新日の
                    <span styleName="red">【10日前】</span>
                    までに申請が必要です。それ以降になってしまった場合は次々回の課金更新日からの適応となります。
                  </div>
                  <div styleName="attention_image">
                    <img src={DesktopWithdrawalPeriodImage1} />
                    <img src={DesktopWithdrawalPeriodImage2} />
                  </div>
                  <div styleName="attention_text">
                    ・退会の申請のお手続きを行っていただいた時点で、申請いただいた退会日以降の受講プランの課金が停止され、退会日を迎えると全ての機能がご利用いただけなくなります。
                    <br />
                    ・一度退会されてしまうと、再入会される場合は入会金のお支払いが再び必要になるのでご注意ください。
                    <br />
                    ・退会日時点で入会金の分割払いが残っている場合には、退会後もご請求が発生いたします。
                    <br />
                    ・退会と同時にご登録情報の削除をご希望の場合には、退会日以降に
                    <a target="_blank" href="https://page.line.me/xzy6836c?openQrModal=true">
                      SHElikes公式LINE
                    </a>
                    までお問い合わせください。
                    <br />
                    ※入会金の分割払いが残っている場合、お支払いが完了次第、ご登録情報の削除が可能となります。
                  </div>
                </div>
                <div styleName="confirmation">
                  <CheckBox
                    checked={checked}
                    onCheck={() => setChecked(!checked)}
                    id={'withdrawal-agreement-confirmation'}
                  >
                    注意事項をよく読み理解しました
                  </CheckBox>
                </div>
              </div>

              <div styleName="submit_button">
                <Button
                  id="proceed-to-withdrawal-form-button"
                  disabled={!checked}
                  onClick={() => GlobalStatesV3.routing.push(V3Routes.withdrawalForm())}
                  fullWidth={GlobalStatesV3.viewport.isSp}
                >
                  退会申請フォームに進む
                </Button>
              </div>
            </PaneBody>
          </Pane>
        </Page>
      );
    })
  )
);
